import React, { FunctionComponent } from 'react'
import { Path, Rect, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export enum PaginationIconType {
  PREV = 'PREV',
  NEXT = 'NEXT',
  FIRST = 'FIRST',
  LAST = 'LAST',
}

export const PaginationIcon: FunctionComponent<PaginationIconProps> = ({
  size = 24,
  fillColor,
  type = PaginationIconType.PREV,
}) => {
  const { colors } = useTheme()
  return (
    <Svg width={size} height={size} fill='none' viewBox='0 0 24 24'>
      {type === PaginationIconType.PREV && (
        <Path
          stroke={fillColor || colors.iconDefault}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.5}
          d='m15 18-6-6 6-6'
        />
      )}
      {type === PaginationIconType.NEXT && (
        <Path
          stroke={fillColor || colors.iconDefault}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.5}
          d='m9 18 6-6-6-6'
        />
      )}
      {type === PaginationIconType.FIRST && (
        <>
          <Path
            stroke={fillColor || colors.iconDefault}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.5}
            d='m18 18-6-6 6-6'
          />
          <Rect
            width={1.5}
            height={14}
            fill={fillColor || colors.iconDefault}
            rx={0.75}
            transform='matrix(-1 0 0 1 7.2 4.8)'
          />
        </>
      )}
      {type === PaginationIconType.LAST && (
        <>
          <Path
            stroke={fillColor || colors.iconDefault}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.5}
            d='m6 18 6-6-6-6'
          />
          <Rect width={1.5} height={14} x={16} y={5} fill={fillColor || colors.iconDefault} rx={0.75} />
        </>
      )}
    </Svg>
  )
}

export type PaginationIconProps = {
  size?: string | number
  fillColor?: string
  type?: PaginationIconType
}
